export default
    [
        {
            path: '/receive',
            name: 'redirect-recieve',
            component: () => import('@/components/common/RedirectRecieve'),
        },
    ]
